export function initFilterSort() {
  const filterWrapper = document.querySelector('.po-filter');
  const filterList = document.querySelector('.po-filter__list');

  if (filterWrapper && filterList) {
    filterWrapper.addEventListener('click', () => {
      filterWrapper.classList.toggle('po-filter_active');
      filterList.classList.toggle('po-filter__list-active');
    });
  }

  const radioButtons = document.querySelectorAll('.po-radio-btn__input');
  const selectedTextElement = document.querySelector(
    '.po-filter__selected-text'
  );
  const urlParams = new URLSearchParams(window.location.search);
  const orderby = urlParams.get('orderby') || '';

  if (orderby && selectedTextElement) {
    radioButtons.forEach((rb) => {
      const label = rb.closest('label');
      const value = label.dataset.orderby;

      if (value === orderby) {
        rb.checked = true;
        selectedTextElement.textContent = label.textContent.trim();
      }
    });
  }

  radioButtons.forEach((rb) => {
    rb.addEventListener('change', () => {
      const selected = document.querySelector('input[name="aa"]:checked');
      if (!selected) return;

      const label = selected.closest('label');
      const sortVal = label.dataset.orderby;
      const labelText = label.textContent.trim();

      if (selectedTextElement) selectedTextElement.textContent = labelText;

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('orderby', sortVal);
      window.location.href = newUrl.href;
    });
  });

  //временное решение вместо пагинации


  const btn = document.getElementById('po-load-more');
  if (!btn) return;

  const container = document.getElementById('po-author-posts');

  btn.addEventListener('click', () => {
    let page = parseInt(btn.dataset.page, 10) + 1;
    const maxPages = parseInt(btn.dataset.max, 10);
    const authorId = btn.dataset.author;
    const category = btn.dataset.category;
    const order = btn.dataset.order;

    btn.disabled = true;
    btn.textContent = 'Download...';

    fetch(`${PO_API.author_posts}?author_id=${authorId}&category=${category}&order=${order}&page=${page}`)
        .then(res => res.json())
        .then(data => {
          if (data.html) {
            container.insertAdjacentHTML('beforeend', data.html);
          }

          btn.dataset.page = page;

          if (page >= maxPages) {
            btn.remove();
          } else {
            btn.disabled = false;
            btn.textContent = 'Show more';
          }
        })
        .catch(() => {
          btn.textContent = 'Error';
        });
  });


}
